import { GlobalIcon } from "get-life-storybook-ts";

interface HelpBlockProps {
  phone?: string;
  translate: (key: string) => string;
}

const HelpBlock = ({ phone, translate }: HelpBlockProps) => {
  if (!phone) return null;
  return (
    <div className="paymentV3HelpBlock">
      <div className="paymentV3HelpBlock__avatar">
        <GlobalIcon iconName="PhoneIcon" size="M" color="#FFFFFF" />
      </div>
      <div className="paymentV3HelpBlock__copy">
        <div className="paymentV3HelpBlock__title">
          {translate("paymentV3.help.title")}
        </div>
        <div className="paymentV3HelpBlock__sub">
          {translate("paymentV3.help.hours")}
        </div>
      </div>
      <a
        className="paymentV3HelpBlock__cta"
        href={`tel:${phone.replace(/\s/g, "")}`}
      >
        {phone}
      </a>
    </div>
  );
};

export default HelpBlock;
